/**
 * Provider
 *
 * Created by Samuel on 2022/5/16
 */
import { useState } from 'react';

import { ConfigContext } from '@core/configProvider/context';
import i18n from '@core/i18n';
import { clearLangCache } from '@core/i18n/lang';

const _INIT_CONFIG = {
	language: navigator.language,
	localesPath: '/locales',
	localesVersion: window._$MG_LOCALES_VERSION,
};

export const ConfigProvider = ({ config, children }) => {
	const [conf, setConf] = useState(() => {
		const _conf = { ..._INIT_CONFIG, ...config };
		_conf.intl = new i18n.MgIntl({
			language: _conf.language,
			path: _conf.localesPath,
			version: _conf.localesVersion || null,
			supportedLanguage: _conf.supportedLanguage,
		});

		return _conf;
	});

	const changeLanguage = (lang) => {
		conf.intl.changeLanguage(lang, () => {
			clearLangCache();
			setConf({
				...conf,
				language: lang,
			});
		});
	};

	return <ConfigContext.Provider value={{ ...conf, changeLanguage }}>{children}</ConfigContext.Provider>;
};
